export default {
  heroSlide1Title: "加速从实验室到生活的医疗保健",
  // heroSlide1Subtitle: "领先的制药创新，拥有40多年的精神药物API和复杂仿制药专业知识",
  heroSlide2Title: "全球覆盖 – 80多个国家的客户",
  // heroSlide2Subtitle: "与全球顶级制药创新者和仿制药公司建立牢固的关系",
  heroSlide3Title: "从基础材料到制剂：一个合作伙伴。完全可靠",
  // heroSlide3Subtitle: "端到端的制药解决方案，涵盖KSM、API和FDF的集成价值链",
  heroSlide4Title: "6个全球设施 | 4个研发中心 | 1个全球制药平台",
  // heroSlide4Subtitle: "世界级的制造和研究基础设施，推动创新和质量卓越",
  heroSlide5Title: "我们的集团公司",
  // heroSlide5Subtitle: "多元化的公司组合，共同提供全面的制药解决方案",
};

